import * as React from 'react'
import { connect } from 'react-redux'
import {
  Form,
  Field,
  reduxForm,
  getFormValues,
} from 'redux-form'
import InputField from '@App/components/fields/InputField'
import { Button } from 'relevant-ui'
import {
  RECOVERY_PASSWORD_EMAIL_LABEL,
  RECOVERY_PASSWORD_FORM,
  SUBMIT,
  BACK_TO_SIGN_IN_LINK,
  HOMEPAGE_ROUTE,
} from '@App/constantes'
import { getRecoveryPassword } from 'actions'
import { Link } from 'react-router-dom'

class RecoveryPasswordForm extends React.Component<any, any, any> {
  constructor(props: any) {
    super(props)

    this.submitForm = this.submitForm.bind(this)
  }

  submitForm() {
    const { recoveryPassword } = this.props
    const email = this.props[RECOVERY_PASSWORD_EMAIL_LABEL]
    recoveryPassword(email)
  }

  render() {
    const {
      handleSubmit,
      pristine,
      submitSucceeded,
    } = this.props

    return (
      <div>
        <Form onSubmit={handleSubmit(this.submitForm)}>
          <Field
            component={InputField}
            name={RECOVERY_PASSWORD_EMAIL_LABEL}
            label={RECOVERY_PASSWORD_EMAIL_LABEL}
            primary
          />
          <div className="link">
            <Link
              to={HOMEPAGE_ROUTE}>
              {BACK_TO_SIGN_IN_LINK}
            </Link>
          </div>
          <div className="wrapperButton">
            <Button
              button="primary"
              size="large"
              type="submit"
              disabled={pristine || submitSucceeded}
              label={SUBMIT}
            />
          </div>
        </Form>
      </div>
    )
  }
}

const validate = (values: any) => {
  const regExp = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  const errors = {}

  if (values[RECOVERY_PASSWORD_EMAIL_LABEL] && !regExp.test(values[RECOVERY_PASSWORD_EMAIL_LABEL])) {
    errors[RECOVERY_PASSWORD_EMAIL_LABEL] = 'Please type an email in correct format'
  }

  return errors
}

const RecoveryPassword = reduxForm<any, any, any>({
  validate,
  form: RECOVERY_PASSWORD_FORM,
})(RecoveryPasswordForm)

const mapStateToProps = (state: any) => {
  const values = getFormValues(RECOVERY_PASSWORD_FORM)(state) || {}
  return {
    ...values,
  }
}

const mapDispatchToProps = (dispatch: Function) => {
  return {
    recoveryPassword: (email: string) => dispatch(getRecoveryPassword(email)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(RecoveryPassword)
